import Menu from 'assets/images/home/Menu.svg'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toggleSideBar } from 'store/redux/sidebar'
interface IHeaderProps {
    title: string
}
export default function Header({ title }: IHeaderProps) {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    return (
        <>
            <div className=" bg-header-bg w-full px-4 py-3 flex justify-between sticky top-0 z-10 shadow-[0px 2px 4px 0px #0000001A] items-center">
                <div className="flex">
                    <img
                        src={Menu}
                        alt="logo"
                        onClick={() =>
                            dispatch(toggleSideBar({ isOpen: true }))
                        }
                        className=" cursor-pointer"
                    />
                </div>
                <p className=" text-green-1 text-xl font-bold">{title}</p>
                <p
                    className=" text-green-1 text-3xl"
                    onClick={() => navigate('/add-box/moneyPool')}
                >
                    +
                </p>
            </div>
        </>
    )
}
